<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} convenio
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <!-- formulario -->
              <div class="row">
                <div class="form-group col-lg-6">
                  <label>Seleccionar empresa<span class="required"></span>
                    <ng-container *ngIf="partnerSelected != null">
                      <span class="m-l-15 bold"><i class="fas fa-phone m-r-5"></i>{{partnerSelected.cellphone}}</span>
                    </ng-container>
                  </label>
                  <ng-container *ngIf="partnerSelected != null">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="{{partnerSelected.tradename}}-{{partnerSelected.document_str}}">
                      <div class="input-group-append bg-custom b-0 removeClient">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          uib-tooltip="Quitar" (click)="removePartner()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="partnerSelected == null">
                    <component-search-partnercompanies [classSize]="'search-small'"
                      (selectedPartnerEvent)="selectedPartnerSearch($event)" class="w-100">
                    </component-search-partnercompanies>
                  </ng-container>
                </div>
                <div class="form-group col-lg-6">
                  <label>Nombre convenio <span class="required"></span></label>
                  <input type="text" class="form-control" formControlName="description" required>
                </div>
                <div class="form-group col-lg-3">
                  <label>Fecha inicio <span class="required"></span></label>
                  <input type="text" class="form-control" formControlName="start_date" id="start_date" required>
                </div>
                <div class="form-group col-lg-3">
                  <label>Fecha Fin <span class="required"></span></label>
                  <input type="text" class="form-control" formControlName="end_date" id="end_date" required>
                </div>
                <div class="form-group col-lg-6">
                  <label>Condiciones</label>
                  <textarea class="form-control no-resize" rows="2" formControlName="conditions"></textarea>
                </div>
              </div>
              <div class="col-lg-12 m-t-20" *ngIf="rates_detail.length == 0">
                <p class="form__group__title f-s-12"> <i class="fas fa-list-alt m-r-3"></i>No se encontraron disponibles
                </p>
              </div>
              <div class="m-t-20" *ngIf="rates_detail.length > 0">
                <p class="form__group__title f-s-13"> <i class="fas fa-list-alt m-r-3"></i>Tarifas disponibles</p>
                <div class="row">
                  <div class="col-lg-6" *ngFor="let item of rates_detail; let index_ = index">
                    <p class="f-s-12 m-b-5 bold text-primary"> <i class="fas fa-info m-r-5"></i> {{item.description}}
                    </p>
                    <ul *ngIf="item.ranges_rate.length > 0">
                      <li class="f-s-10" *ngFor="let dates of item.ranges_rate">
                        {{dates.start_date | date: 'mediumDate'}} - {{dates.end_date| date: 'mediumDate'}}</li>
                    </ul>
                    <div class="table-responsive m-b-20">
                      <table class="table mb-0 table-sm table-hover">
                        <thead class="thead-default">
                          <tr>
                            <th>Tipo Hab.</th>
                            <th class="text-center">P.Publicado</th>
                            <th class="text-center position-relative">P.Convenio <span class="required"></span></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let room of item.rates_roomtype; let index_detail = index">
                            <td>{{room.roomtype_data.description}}</td>
                            <td class="text-center">{{toolsService.momeySol()}}{{room.price_public}}</td>
                            <td class="text-center">
                              <div class="input-group">
                                <div class="input-group-prepend"><span
                                    class="input-group-text f-s-12">{{toolsService.momeySol()}}</span>
                                </div>
                                <input type="text" id="price_agreement{{index_}}{{index_detail}}"
                                  class="form-control form-control-xs text-center" value="{{room.agreement}}"
                                  (keyup)="changePriceAgreement($event.target,index_, index_detail)" numeric
                                  decimals="2" onclick="click_input(this)">
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
